// Catalog product bundle (product details, CMS product pages, developer)
import '../css/pages/catalog/product/product-details.css';
import '../css/pages/catalog/cms/style.css';

// Note: update.js is already loaded globally via the layout
// (alambil.phtml line 31), so it's intentionally NOT bundled here.
// Note: the wish-list widget (CSS + product-add-widget.js) lives in its
// own `wish-list` bundle so it can also be loaded on the New Releases
// modal without pulling in the rest of catalog-product.
import { runLegacy } from './helpers/load-legacy';
import mediaelementJs     from '../js/vendor/mediaelement/mediaelement-and-player.min.js?legacy';
import pageJs             from '../js/pages/catalog/page/page.js?legacy';

runLegacy(
    mediaelementJs,
    pageJs,
);
